import { render, staticRenderFns } from "./SolicitudAdicional.vue?vue&type=template&id=5f81c8b6"
import script from "./SolicitudAdicional.vue?vue&type=script&lang=js"
export * from "./SolicitudAdicional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports